import { render, staticRenderFns } from "./redenvelopeto-record.vue?vue&type=template&id=3b21eb1e&scoped=true"
import script from "./redenvelopeto-record.vue?vue&type=script&lang=js"
export * from "./redenvelopeto-record.vue?vue&type=script&lang=js"
import style0 from "./redenvelopeto-record.vue?vue&type=style&index=0&id=3b21eb1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b21eb1e",
  null
  
)

export default component.exports